import { Component } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseDataStoreCRUDServer } from '@m4u-angular/base/datalayer/BaseDataStoreCRUDServer';
import { BaseEntity, BaseState, NotificationServer } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationServerEndpoint } from '@m4u-angular/core/endpoints/notification-server.endpoint';
import { EnumCRUDActions } from '@m4u-angular/core/framework/sysenums.enum';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-server-list',
    templateUrl: './notification-server-list.component.html',
    styleUrls: ['./notification-server-list.component.scss']
})
export class NotificationServerListComponent extends BasePageComponent<BaseEntity, BaseState> {

    constructor(A: ServiceBagService,
        private notificationServerEndpoint: NotificationServerEndpoint) {
        super(A, 'NotificationServerListComponent', BaseEntity, BaseState);
    }

    protected override OnInitComponent() {
        this.LoadDataSource();
    }

    protected override OnExternalEntitySaved(ExternalEntity: BaseEntity, ExternalEntityType: new () => BaseEntity, ExternalEntityAction: EnumCRUDActions) {
        if (ExternalEntityType === NotificationServer) this.LoadDataSource();
    }

    LoadDataSource() {
        this.DataSources['NotificationServers'] = new BaseDataStoreCRUDServer(this.notificationServerEndpoint);
    }

    OnNavigate() {
        this.Navigate(['/pages/general/notification-server/new']);
    }
}
